import {Experiment, FeatureApiResponse, GrowthBook, Result, TrackingData} from "@growthbook/growthbook";

export interface GrowthbookClientData {
    payload: FeatureApiResponse;
    trackingData: TrackingData[];
    userId?: string;
}

export default function getGrowthbookConfig(gbuuid?: string) {
    const config = {
        ...getGrowthbookInitialConfig(gbuuid),
        enableDevMode: process.env.APP_ENV === 'dev',
        trackingCallback: (experiment: Experiment<any>, result: Result<any>) => {
            console.log('Tracking experiment:', experiment.key, 'result:', result.variationId)
            if (typeof window !== 'undefined') {
                const dataLayer = (window as any).dataLayer || []
                dataLayer.push({
                    event: 'experiment_viewed',
                    event_category: 'experiment',
                    experiment_id: experiment.key,
                    variation_id: result.variationId,
                    gb_user_id: gbuuid,
                    anonymous_id: gbuuid,
                    user_id: gbuuid,
                    user_pseudo_id: gbuuid,
                });
            } else {
                console.log('GB tracking aborted, window is undefined')
            }
        },
    }

    return config
}

export function getGrowthbookInitialConfig(gbuuid?: string) {
    return {
        apiHost: process.env.NEXT_PUBLIC_GROWTHBOOK_API_HOST,
        clientKey: process.env.NEXT_PUBLIC_GROWTHBOOK_CLIENT_KEY,
        decryptionKey: process.env.NEXT_PUBLIC_GROWTHBOOK_DECRYPTION_KEY,
        attributes: {
            id: gbuuid,
            clientId: gbuuid,
            anonymousId: gbuuid,
        }
    }
}

export const initGrowthbookClient = (gbData: GrowthbookClientData) => {
    const {payload, trackingData, userId} = gbData
    const gb = new GrowthBook(getGrowthbookConfig(userId));
    gb.initSync({ payload })
    gb.setDeferredTrackingCalls(trackingData);
    gb.fireDeferredTrackingCalls();

    return gb
}
